// =====Modules=======
import { FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMasonryModule } from 'ngx-masonry';
import { SharedModule } from './../../shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';

// =====Components=====
import { EnvironmentCustomComponent } from './environment-custom.component';

// =====Services=======
import { EnvironmentCustomService } from './services/environment-custom.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AddPropertyModalComponent } from './add-property-modal/add-property-modal';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ModalModule,
    CommonModule,
    FormsModule,
    NgxMasonryModule,
    SharedModule
  ],
  declarations: [
    EnvironmentCustomComponent,
    AddPropertyModalComponent
  ],
  exports: [EnvironmentCustomComponent, AddPropertyModalComponent],
  providers: [
    EnvironmentCustomService
  ],
  schemas : [CUSTOM_ELEMENTS_SCHEMA]
})
export class EnviromentCustomModule { }
